var vars = require('./core');

module.exports = vars.createClass('Line', ['getPointsAtEvent']);



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-chartjs/lib/line.js
// module id = 993
// module chunks = 0